import React from "react";

import classes from "./Backdrop.module.css";

const Backdrop = (props) => {
    let BacdropClasses = `${classes.Backdrop} ${classes.Closed}`;
    if (props.show){
        BacdropClasses = `${classes.Backdrop} ${classes.Open}`
    }
    return (
        <div className={BacdropClasses}
            onClick={event=>{
                props.closeBackdrop()
            }}
        ></div>
    )
};

export default Backdrop;